
export const DEFAULT_SORT = 'latest';

export type SortOption = {
  value: string;
  label: string;
  query: Record<string, 'asc' | 'desc'>[];
};

export const SORT_OPTIONS: SortOption[] = [
  { value: 'latest', label: 'Najnowsze', query: [{ createdAt: 'desc' }] },
  { value: 'oldest', label: 'Najstarsze', query: [{ createdAt: 'asc' }] },
];

export function getPreparedSortData(sortBy: string | null | undefined): SortOption['query'] | null {
  if (!sortBy) return null;
  return SORT_OPTIONS.find((option) => option.value === sortBy)?.query ?? null;
}

